
import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

import BoxReportPage from "./index.box";
import CloudReportPage from "./index.cloud";
import DemoReportPage from "./index.demo";


export default class Web extends mixin(environment.nexus, {
    box: BoxReportPage,
    cloud: CloudReportPage,
    demo: DemoReportPage,
}) { }
